import type { PastEvent } from "@/services/api/pastEvents";
import { EVENT_TYPE_LABELS, formatEventDate, formatTicketPrice } from "@/pages/Gatherings/lib/eventFormat";
import CalendarIcon from "@/components/SVGComponents/CalendarIcon";
import LocationPinIcon from "@/components/SVGComponents/LocationPinIcon";
import styles from "../PastEvents.module.scss";

interface PastEventCardProps {
  event: PastEvent;
}

const getCityName = (event: PastEvent) => {
  if (event.cityName) return event.cityName;
  if (typeof event.city === "string" && event.city) return event.city;
  return event.locations?.[0]?.cityName || event.cities?.[0] || "—";
};

const PastEventCard = ({ event }: PastEventCardProps) => {
  const eventType = event.eventType ?? event.type;
  const eventTypeLabel = eventType
    ? (EVENT_TYPE_LABELS as Record<string, string>)[eventType] ?? eventType
    : "—";
  const cityName = getCityName(event);
  const date = event.eventDate ?? event.date;
  const formattedDate = date ? formatEventDate(date) : "—";
  const formattedPrice = formatTicketPrice(event.ticketPrice ?? null);

  return (
    <div className={styles.mobileEventCard}>
      {/* Title & Type Badge */}
      <div className={styles.mobileEventHeader}>
        <h3 className={styles.mobileEventName}>{event.name || "—"}</h3>
        <span className={styles.mobileEventTypeBadge}>{eventTypeLabel}</span>
      </div>

      {/* Date & Location */}
      <div className={styles.mobileEventMetaRow}>
        <div className={styles.mobileMetaItem}>
          <CalendarIcon className={styles.mobileMetaIcon} />
          <span>{formattedDate}</span>
        </div>
        <div className={styles.mobileMetaItem}>
          <LocationPinIcon className={styles.mobileMetaIcon} />
          <span>{cityName}</span>
        </div>
      </div>

      <div className={styles.mobileCardDivider} />

      {/* Capacity & Ticket Price */}
      <div className={styles.mobileEventGrid}>
        <div className={styles.mobileEventField}>
          <span className={styles.mobileFieldLabel}>Capacity</span>
          <span className={styles.mobileFieldValue}>{event.capacity || "—"}</span>
        </div>

        <div className={styles.mobileEventField}>
          <span className={styles.mobileFieldLabel}>Ticket Price</span>
          <span className={styles.mobileFieldValue}>{formattedPrice}</span>
        </div>
      </div>
    </div>
  );
};

export default PastEventCard;
